import { Injectable } from '@tanbo/vue-di-plugin'
import { Http } from '@/services/http'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'
import { ParamsClean } from '@/common/decorators/params-clean'

export interface TrustParams {
  page: number
  limit: number
}
export interface TrustItem {
  /** 顺序,true-正序,false-逆序 */
  asc?: boolean
  /** 结束时间 */
  end_time?: number
  /** 搜索关键词 */
  key_word?: string
  /** 风险项 */
  risk_item?: number
  /** 风险类型 */
  risk_types?: number[]
  /** 查杀类型 */
  scan_type?: number
  /** 处理状态，0-全部,1-未处理(包括3-处理失败),2-已处理 ,4-已信任 */
  handle_status?: number
  limit?: number
  /** 仅看未处理 */
  only_untreated?: boolean
  page?: number
  /** 排序字段 */
  sort?: string
  /** 开始时间 */
  start_time?: number
  /** 扫描批次id */
  task_id?: string
  device_id?: string
  /** 分组id */
  group_id?: number
}
export interface TrustResponse {
  list?: TrustItem[]

  /** 总数 */
  total?: number
}
export interface AddTrustParams {
  execute_type: 0 | 1 | 2
  device_id: string
  md5: string
}

@Injectable()
export class RiskItemService {
  constructor(private http: Http) { }
  // 信任区列表
  @ParamsClean()
  getTrustZoneList(data: TrustParams) {
    return this.http.post<TrustResponse>('/safemonitor/virus-scan/trust_zone', data)
  }
  // 隔离区列表
  @ParamsClean()
  getQuarantineZoneList(data: TrustParams) {
    return this.http.post<TrustResponse>('/safemonitor/virus-scan/quarantine_zone', data)
  }
  //添加信任
  addTrust(data: AddTrustParams) {
    return this.http.post<void>('/terminal-order/virus-scan/add_trust', data)
  }
  //恢复文件
  recoverFile(data: TrustParams) {
    return this.http.post<void>('/terminal-order/virus-scan/recover', { data })
  }
  //处理风险项
  processRisk(data: TrustParams) {
    return this.http.post<void>('/terminal-order/virus-scan/process', { data })
  }
  //移除信任
  delTrust(data: TrustParams) {
    return this.http.post<void>('/terminal-order/virus-scan/del_trust', { data })
  }
  // 刷新隔离区
  rfQuarantine(device_id: string) {
    return this.http.post<void>('/terminal-order/virus-scan/update_quarantine', { device_id })
  }
  // 刷新信任区
  rfTrust(device_id: string) {
    return this.http.post<void>('/terminal-order/virus-scan/update_trust', { device_id })
  }
}
